// extracted by mini-css-extract-plugin
export default {"cardsContainer":"missionValues_cardsContainer__qX0An","card":"missionValues_card__PHyB8"};